/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_invite_page_toast_already_accepted_login = /** @type {(inputs: {}) => string} */ () => {
	return `Ya han aceptado esta invitación. Inicia sesión para continuar.`
};

const en_invite_page_toast_already_accepted_login = /** @type {(inputs: {}) => string} */ () => {
	return `This invitation has already been accepted. Log in to continue.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const invite_page_toast_already_accepted_login = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.invite_page_toast_already_accepted_login(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("invite_page_toast_already_accepted_login", locale)
	if (locale === "es") return es_invite_page_toast_already_accepted_login(inputs)
	return en_invite_page_toast_already_accepted_login(inputs)
};
export { invite_page_toast_already_accepted_login as "invite.page.toast_already_accepted_login" }